import { FunnelConfig } from '~/utils/funnels';
import { store } from '~/utils/store';

export const config: FunnelConfig = {
  id: 'dashboardBillpayUpgrade',
  path: '/dashboard-billpay-upgrade',
  show: () => !!store.get('TOKEN'),
};
